export default {
  title: 'Pakketfulfillments instellen',
  form: {
    title: 'Fulfillment aanmaken',
    companies: {
      label: 'Bedrijven',
    },
  },
  table: {
    title: 'Fulfillmentgeschiedenis',
    fields: {
      name: 'Bedrijf',
      fulfilled: 'Uitgevoerd op',
    },
  },
  buttons: {
    create_fulfillment: 'Fulfillment aanmaken',
  },
  toasts: {
    failed_to_load_data: 'Laden van gegevens mislukt',
    failed_to_create_fulfillment: 'Aanmaken van fulfillment mislukt',
  },
};
